// // material-ui
// import { styled } from '@mui/material/styles';
// import { CircularProgress } from '@mui/material/index';
// // loader style
// const LoaderWrapper = styled('div')(({ theme }) => ({
//   // position: 'fixed',
//   // top: 0,
//   // left: 0,
//   // zIndex: 2001,
//   // width: '100%',
//   // '& > * + *': {
//   //   marginTop: theme.spacing(2)
//   // }
// }));

// // ==============================|| Loader ||============================== //

// const LoaderCircular = ({ size, color }) => (
//   <LoaderWrapper>
//     <CircularProgress color={color ? color : 'primary'} size={size ? size : 48} />
//   </LoaderWrapper>
// );

// export default LoaderCircular;

import React from 'react';
import { useTheme } from '@mui/material/styles';
import clsx from 'clsx';

/**
 * Reusable Spinner Component
 * @param {number} size - Size of the spinner in pixels (e.g., 2, 20, 48)
 * * @param {number} stroke - thickness of the spinner in pixels (e.g., 2, 20, 48)
 * @param {'primary' | 'secondary' | 'tertiary'} color - Color variant using theme colors
 * @param {string} className - Additional CSS classes
 */
export default function LoaderCircular({ size = 24, color = 'primary', className = '', stroke = 4 }) {
  const theme = useTheme();

  // Map color prop to theme colors
  const getColor = () => {
    switch (color) {
      case 'primary':
        return theme.palette.primary.main;
      case 'secondary':
        return theme.palette.secondary.main;
      case 'tertiary':
        // Fallback if tertiary doesn't exist in your theme
        return theme.palette.tertiary?.main || theme.palette.grey[600];
      default:
        return theme.palette.primary.main;
    }
  };

  return (
    <svg
      className={clsx('animate-spin', className)}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        color: getColor()
      }}
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth={stroke} className="opacity-25" />
      <path
        fill="currentColor"
        className="opacity-75"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}
